<template>
  <div class="Questioninfo">
    <div class="title" :class="operation=='Detail'?'form_Readonly':''">
      <span
        style="color:red"
        v-if="item.isMust"
      >*</span>
      <span>{{item.number}}、</span>
      <el-input v-model="item.title" />
      <div class="Questioninfo_Copy">
        <a
          href="javascript:void(0);"
          @click="DocumentCopy"
          style="color: #707070;"
        >
          <el-icon>
            <document-copy />
          </el-icon>
        </a>
        <a
          href="javascript:void(0);"
          @click="DeleteFilled"
          style="color: #707070;"
        >
          <el-icon>
            <delete-filled />
          </el-icon>
        </a>
      </div>
    </div>
    <div class="content" :class="operation=='Detail'?'form_Readonly':''">
      <div class="option">
        <!-- 单选 -->
        <el-radio-group
          v-if="item.type==0"
          v-model="radio"
          @change="radiochanged"
        >
          <div
            class="option_children"
            v-for="(option,index) in item.questionOptions"
            :key="index"
          >
            <el-radio
              :label="index"
              size="large"
              v-model="option.isDefault"
            >{{''}}</el-radio>
            <el-input v-model="option.name" />
            <div class="circle-close-filled">
              <el-tooltip
                class="box-item"
                effect="dark"
                content="删除"
                placement="top"
              >
                <a
                  href="javascript:void(0);"
                  :index="index"
                  @click="delOptions(index)"
                  style="color: red;"
                >
                  <el-icon>
                    <circle-close-filled />
                  </el-icon>
                </a>
              </el-tooltip>
            </div>
          </div>
        </el-radio-group>
        <!-- 多选 -->
        <el-checkbox-group
          v-else
          v-model="checkList"
          @change="checkboxchanged"
        >
          <div
            class="option_children"
            v-for="(option,index) in item.questionOptions"
            :key="index"
          >
            <el-checkbox :label="index">{{''}}</el-checkbox>
            <el-input v-model="option.name" />
            <div class="circle-close-filled">
              <el-tooltip
                class="box-item"
                effect="dark"
                content="删除"
                placement="top"
              >
                <a
                  href="javascript:void(0);"
                  @click="delOptions(index)"
                  style="  color: red;"
                >
                  <el-icon>
                    <circle-close-filled />
                  </el-icon>
                </a>
              </el-tooltip>
            </div>
          </div>
        </el-checkbox-group>

      </div>

      <div class="operation">
        <div class="operation_item">
          <a
            href="javascript:void(0);"
            @click="AddOpertion"
          >
            <span class="operation_item_ioc_1"></span>
            <span class="operation_item_text">添加选项</span>
          </a>
        </div>
        <div class="operation_item">
          <a
            href="javascript:void(0);"
            @click="dialogFormVisible = true"
          >
            <span class="operation_item_ioc_2"></span>
            <span class="operation_item_text">批量添加选项</span>
          </a>
        </div>
      </div>
    </div>

    <el-dialog
      v-model="dialogFormVisible"
      title="批量添加选项"
    >
      <div>
        <hr>
        <span style="  display: block; margin: 10px 0 ; ">每行代表一个选项，可以添加多个选项</span>
        <el-input
          v-model="batchTextArea"
          :rows="10"
          type="textarea"
          placeholder="选项1
选项2"
        />
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click="AddbatchText"
          >确认</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { watch, ref, inject, provide, computed } from "vue";
import { ElMessage } from 'element-plus';
export default {
  name: "QuestionnaireChoice",
  props: {
    item: {
      type: Object,
      default: {
        title: "请选择一个选项",
        type: 0, //类型
        number: 1, //序号
        isRandom: false, //是否随机
        isMust: true, //是否必填
        questionOptions: [
          {
            name: "选项1",
            isDefault: false, //是否默认选中
            number: 1, //序号
          },
        ],
      },
    },
    dataindex: {
      type: Number,
      default: 0,
    },
    operation: {
      type: String,
      default: ""
    }
  },
  setup(props, context) {
    const dialogFormVisible = ref(false);
    const batchTextArea = ref("");
    const AddbatchText = () => {
      dialogFormVisible.value = false;
      batchTextArea.value.split(/[(\r\n)\r\n]+/).forEach((item) => {
        let option = {
          number: props.item.questionOptions.length + 1,
          name: item,
        };
        if (props.item.hasOwnProperty("id")) {
          //对已有的数据进行添加选项
          option.questionTopicId = props.item.id;
        }
        props.item.questionOptions.push(option);
      });
      console.log(batchTextArea.value);
    };
    //复制
    const DocumentCopy = () => {
      context.emit("DocumentCopy", props.item);
    };

    //删除
    const DeleteFilled = () => {
      context.emit("DeleteFilled", props.dataindex);
    };

    //添加选项
    const AddOpertion = () => {
      let option = {
        name: "选项" + (props.item.questionOptions.length + 1),
        isDefault: false,
        number: props.item.questionOptions.length + 1,
      };
      if (props.item.hasOwnProperty("id")) {
        //对已有的数据进行添加选项
        option.questionTopicId = props.item.id;
      }
      props.item.questionOptions.push(option);
      console.log(props.item);
    };

    //删除选项
    const delOptions = (index) => {
      props.item.questionOptions.splice(index, 1);
      //删除后重置序号
      for(let i = 0;i < props.item.questionOptions.length;i ++) {
        let item = props.item.questionOptions[i];
        item.number = i + 1;
      }
      ElMessage.success("删除成功!");
    };

    //单选
    const radio = computed(() => {
      if (props.item.questionOptions.length > 0) {
        let defaultoption = props.item.questionOptions.find((option) => {
          return option.isDefault == true;
        });
        if (defaultoption) {
          let index = props.item.questionOptions.indexOf(defaultoption);
          return index;
        }
      }
      return "";
    });

    //单选变化事件
    const radiochanged = (e) => {
      if (props.item.questionOptions.length > 0) {
        let option = props.item.questionOptions[e];
        option.isDefault = !option.isDefault;
        if (option.isDefault) {
          //更新其他选项为不选中
          for (let i = 0; i < props.item.questionOptions.length; i++) {
            if (i != e) {
              props.item.questionOptions[i].isDefault = false;
            }
          }
        }
      }
    };

    //多选
    const checkList = computed(() => {
      let list = [];
      if (props.item.questionOptions.length > 0) {
        let defaultoption = props.item.questionOptions.filter((option) => {
          return option.isDefault == true;
        });
        if (defaultoption.length > 0) {
          defaultoption.forEach((option) => {
            let index = props.item.questionOptions.indexOf(option);
            list.push(index);
          });
        }
      }
      return list;
    });

    //多选变化事件
    const checkboxchanged = (e) => {
      if (props.item.questionOptions.length > 0) {
        for (let i = 0; i < props.item.questionOptions.length; i++) {
          if (e.includes(i)) {
            props.item.questionOptions[i].isDefault = true;
          } else {
            props.item.questionOptions[i].isDefault = false;
          }
        }
      }
    };

    return {
      AddOpertion,
      dialogFormVisible,
      delOptions,
      DocumentCopy,
      DeleteFilled,
      AddbatchText,
      batchTextArea,
      radio,
      checkList,
      radiochanged,
      checkboxchanged,
    };
  },
};
</script>

<style lang="scss" scoped>
.form_Readonly {
  pointer-events: none;
}
.Questioninfo {
  background-color: #ffffff;
  padding: 10px 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;

  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .Questioninfo_Copy {
      width: 10%;
      // background-color: yellow;

      height: 40px;
      line-height: 40px;
      align-self: center;
      font-size: 26px;
      display: flex;
      justify-content: flex-start;
    }

    .Questioninfo_Copy a:nth-child(1) {
      margin-right: 5px;
    }
  }

  //内容区
  .content {
    .option {
      .option_children {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        //background-color: greenyellow;
        // .circle-input{
        //     width: 80%;
        //     background-color: green;
        // }

        .circle-close-filled {
          width: 20%;
          margin-left: 10px;
        }
      }
    }

    .operation {
      display: flex;
      justify-content: flex-start;

      .operation_item {
        //background-color: red;
        font-size: 26px;
        height: 26px;
        color: #0747a6;

        a {
          text-align: center;
          height: 30px;
          line-height: 30px;
          display: inline-block;
          vertical-align: middle;
        }

        //width: 100px;
        margin-right: 100px;

        .operation_item_ioc_1 {
          display: inline-block;
          vertical-align: middle;
          width: 16px;
          height: 16px;
          margin-right: 5px;
          background: url(../../../assets/Slice3.png) no-repeat;
          background-size: cover;
        }

        .operation_item_ioc_2 {
          display: inline-block;
          vertical-align: middle;
          width: 16px;
          height: 16px;
          margin-right: 5px;
          background: url(../../../assets/add2.png) no-repeat;
          background-position: 10%, 40%, 80%;
          background-size: cover;
        }

        .operation_item_ioc_3 {
          display: inline-block;
          vertical-align: middle;
          width: 25px;
          height: 25px;
          margin-right: 5px;
          background: url(../../../assets/Slice3.png) no-repeat;
          background-size: cover;
        }
        .operation_item_text {
          font-size: 13px;
        }
      }
    }
  }
}

.Questioninfo:hover {
  border: solid 1px blue;
}
</style>

<style scoped>
.option_children /deep/ .el-radio {
  margin: 0;
}

.title /deep/ .el-input__inner {
  font-size: 16px;
  line-height: 50px;
  width: 100%;
  font-weight: 600px;
  border: 0;

  color: #000;
}

.option_children /deep/ .el-input__inner {
  font-size: 16px;
  line-height: 50px;
  background-color: #ffffff;
  border: 0;
  margin-left: 5px;
  padding: 0;
}
.option /deep/ .el-radio-group {
  width: 100%;
}
</style>
